import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../lib/content";

export default function IndustriesBento() {
  // 7 industries - tetris layout
  const rows = [
    [{ idx: 0, span: "md:col-span-7" }, { idx: 1, span: "md:col-span-5" }],
    [
      { idx: 2, span: "md:col-span-4" },
      { idx: 3, span: "md:col-span-4" },
      { idx: 4, span: "md:col-span-4" },
    ],
    [{ idx: 5, span: "md:col-span-5" }, { idx: 6, span: "md:col-span-7" }],
  ];

  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="industries-bento">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 items-end mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#F37021]" />
              <span className="text-eyebrow text-[#F37021]">Our Industries</span>
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#0A1F3F]">
              Seven industries.
              <br />
              One trading house.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-base sm:text-lg text-[#4B5668] leading-relaxed">
              From rail infrastructure and aviation technology to petrochemicals,
              agriculture, heavy equipment and telecommunications — BNM Group
              structures physical trade across the industries that move the
              global economy.
            </p>
          </div>
        </div>

        <div className="space-y-6 lg:space-y-8">
          {rows.map((row, ri) => (
            <div key={ri} className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
              {row.map(({ idx, span }) => (
                <BentoCard
                  key={idx}
                  industry={INDUSTRIES[idx]}
                  className={`${span} h-[380px] md:h-[420px]`}
                  large={idx === 0 || idx === 6}
                />
              ))}
            </div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/industries"
            data-testid="industries-view-all"
            className="inline-flex items-center gap-3 border border-[#0A1F3F] hover:bg-[#0A1F3F] hover:text-white px-8 py-5 text-xs uppercase tracking-[0.2em] font-semibold transition-colors"
          >
            All industries
            <ArrowUpRight className="w-4 h-4 arrow-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
}

function BentoCard({ industry, className = "", large = false }) {
  return (
    <Link
      to={`/industries/${industry.id}`}
      data-testid={`bento-industry-${industry.id}`}
      className={`relative group overflow-hidden bg-[#0A1F3F] text-white ${className}`}
    >
      <img
        src={industry.image}
        alt={industry.title}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F3F]/95 via-[#0A1F3F]/40 to-[#0A1F3F]/10" />
      <div className="absolute top-6 right-6 w-10 h-10 border border-white/40 flex items-center justify-center group-hover:bg-[#F37021] group-hover:border-[#F37021] transition-colors">
        <ArrowUpRight className="w-4 h-4" />
      </div>
      <div className="relative h-full flex flex-col justify-between p-8">
        <div className="text-eyebrow text-white/70">{industry.number}</div>
        <div>
          <h3
            className={`font-display font-black tracking-tighter ${
              large ? "text-3xl sm:text-4xl" : "text-2xl sm:text-3xl"
            } leading-[1.02]`}
          >
            {industry.title}
          </h3>
          {large && (
            <p className="mt-3 text-sm text-white/80 max-w-md leading-relaxed">
              {industry.description}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
